<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-4">
        <div class="row">
          <div class="col-md-12">
            <label class="required">{{
              $t('dailyCashAdvance.advanceDate')
            }}</label>
            <a-date-picker
              v-model="model.advance_date"
              format="DD-MM-YYYY"
              :allowClear="false"
              valueFormat="DD-MM-YYYY"
              class="ts-w-full"
            ></a-date-picker>
            <div class="validate ts-text-xs" v-if="errors.has('advance_date')">
              {{ errors.first('advance_date') }}
            </div>
          </div>
          <div class="col-md-12">
            <label class="required ts-mt-4">{{
              $t('dailyCashAdvance.currency')
            }}</label>
            <a-select
              v-model="model.currency_id"
              :options="currencies"
              class="ts-w-full"
            ></a-select>
            <div class="validate ts-text-xs" v-if="errors.has('currency_id')">
              {{ errors.first('currency_id') }}
            </div>
          </div>
          <div class="col-md-12">
            <label class="required ts-mt-4">{{
              $t('dailyCashAdvance.purpose')
            }}</label>
            <a-input
              v-model="model.purpose"
              :placeholder="$t('dailyCashAdvance.purpose')"
              class="ts-w-full"
            />
            <div class="validate ts-text-xs" v-if="errors.has('purpose')">
              {{ errors.first('purpose') }}
            </div>
          </div>

          <div class="col-md-12">
            <label class="required ts-mt-4">{{
              $t('dailyCashAdvance.advanceAmount')
            }}</label>
            <a-input
              v-model.number="model.advance_amount"
              :placeholder="$t('dailyCashAdvance.advanceAmount')"
              class="ts-w-full"
            />
            <div
              class="validate ts-text-xs"
              v-if="errors.has('advance_amount')"
            >
              {{ errors.first('advance_amount') }}
            </div>
          </div>
          <div class="col-md-12">
            <label class="ts-mt-4">{{
              $t('dailyCashAdvance.vendorName')
            }}</label>
            <a-input
              v-model="model.vendor_name"
              :placeholder="$t('dailyCashAdvance.vendorName')"
              class="ts-w-full"
            />
            <div class="validate ts-text-xs" v-if="errors.has('vendor_name')">
              {{ errors.first('vendor_name') }}
            </div>
          </div>
          <div class="col-md-12">
            <label class="required ts-mt-4">{{
              $t('dailyCashAdvance.advancedBy')
            }}</label>
            <a-select
              v-model="model.advanced_by"
              :options="employeeProfileOptions"
              showSearch
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              class="ts-w-full"
            ></a-select>
            <div class="validate ts-text-xs" v-if="errors.has('advanced_by')">
              {{ errors.first('advanced_by') }}
            </div>
          </div>
          <div class="col-md-6">
            <label class="required ts-mt-4">{{
              $t('dailyCashAdvance.paymentMethod')
            }}</label>
            <a-select
              v-model="model.payment_method_id"
              :options="paymentMethodOptions"
              showSearch
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              @change="onPaymentMethodChange"
              class="ts-w-full"
            ></a-select>
            <div
              class="validate ts-text-xs"
              v-if="errors.has('payment_method_id')"
            >
              {{ errors.first('payment_method_id') }}
            </div>
          </div>
          <div class="col-md-6">
            <label class="ts-mt-4" :class="isBank ? '' : 'required'">{{
              $t('dailyCashAdvance.bank')
            }}</label>
            <a-select
              v-model="model.bank_id"
              :options="bankNameOptions"
              :disabled="isBank"
              showSearch
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              class="ts-w-full"
            ></a-select>
            <div class="validate ts-text-xs" v-if="errors.has('bank_id')">
              {{ errors.first('bank_id') }}
            </div>
          </div>
          <div class="col-md-6">
            <label class="ts-mt-4" :class="isBank ? '' : 'required'">{{
              $t('dailyCashAdvance.accountName')
            }}</label>
            <a-input
              v-model="model.account_name"
              :disabled="isBank"
              :placeholder="$t('dailyCashAdvance.accountName')"
              class="ts-w-full"
            />
            <div class="validate ts-text-xs" v-if="errors.has('account_name')">
              {{ errors.first('account_name') }}
            </div>
          </div>
          <div class="col-md-6">
            <label class="ts-mt-4" :class="isBank ? '' : 'required'">{{
              $t('dailyCashAdvance.accountNumber')
            }}</label>
            <a-input
              v-model="model.account_number"
              :disabled="isBank"
              :placeholder="$t('dailyCashAdvance.accountNumber')"
              class="ts-w-full"
            />
            <div
              class="validate ts-text-xs"
              v-if="errors.has('account_number')"
            >
              {{ errors.first('account_number') }}
            </div>
          </div>
          <div class="col-md-12">
            <label class="ts-mt-4">{{
              $t('dailyCashAdvance.description')
            }}</label>
            <textarea
              rows="3"
              class="form-control"
              :placeholder="$t('dailyCashAdvance.description')"
              v-model.trim="model.description"
            ></textarea>
            <div class="validate ts-text-xs" v-if="errors.has('description')">
              {{ errors.first('description') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-flex ts-justify-end ts-space-x-3">
            <ts-button @click="$emit('cancel')">{{ $t('cancel') }}</ts-button>
            <ts-button
              color="primary"
              outline
              v-if="!isEdit"
              :waiting="waiting_new"
              @click.prevent="onSaveAddNew"
              >{{ $t('save_add_new') }}</ts-button
            >
            <ts-button
              v-if="!isEdit"
              color="primary"
              :waiting="waiting"
              @click.prevent="onSave"
              >{{ $t('save') }}</ts-button
            >
            <ts-button
              v-if="isEdit"
              color="primary"
              :waiting="waiting"
              @click.prevent="onUpdate"
              >{{ $t('update') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'formCreatePaymentToVendor',
  data () {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      bankProfiles: [],
      employeeProfiles: [],
      currencies: [],
      paymentMethods: [],
      model: {
        advance_id: null,
        advance_date: moment().format('DD-MM-YYYY'),
        currency_id: null,
        advance_amount: null,
        amount_used: 0,
        amount_due: 0,
        purpose: null,
        description: null,
        fx_rate: null,
        vendor_name: null,
        advanced_by: null,
        bank_id: null,
        account_name: null,
        account_number: null,
        payment_method_id: 1
      }
    }
  },
  async created () {
    await this.setEditData()
    await this.fetchResource()
    this.model.fx_rate = parseFloat(
      this.$store.state.authUser.sys_setting.fx_rate
    )
  },
  computed: {
    ...mapState('expense/dailyCashAdvance', ['stockin', 'edit_data']),
    paymentMethodOptions () {
      return this.paymentMethods.map(el => ({
        value: el.payment_method_id,
        label: el.payment_method
      }))
    },
    bankNameOptions () {
      return this.bankProfiles.map(el => ({
        value: el.bank_id,
        label: el.bank_name
      }))
    },
    employeeProfileOptions () {
      return this.employeeProfiles.map(el => ({
        value: el.employee_id,
        label: el.employee_name_en
      }))
    },
    isEdit () {
      return !_.isEmpty(this.edit_data)
    },
    isBank () {
      return this.model.payment_method_id == 1 ? true : false
    }
  },
  methods: {
    ...mapActions('expense/dailyCashAdvance', [
      'store',
      'update',
      'getPaymentMethod',
      'getBankProfile',
      'getEmployee',
      'getCurrency'
    ]),
    async fetchResource () {
      this.loading = true
      await this.getPaymentMethod()
        .then(response => {
          this.paymentMethods = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      await this.getBankProfile()
        .then(response => {
          this.bankProfiles = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      await this.getEmployee()
        .then(response => {
          this.employeeProfiles = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      await this.getCurrency()
        .then(response => {
          this.currencies = response.data.map(el => ({
            value: el.currency_id,
            label: el.currency_code,
            is_default: el.is_default
          }))
          if (!this.isEdit) {
            const currency = this.currencies.find(e => e.is_default == true)
            this.model.currency_id = currency ? currency.value : null
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onPaymentMethodChange () {
      this.model.bank_id = null
      this.model.account_name = null
      this.model.account_number = null
    },
    onUpdate () {
      this.waiting = true
      this.update({
        id: this.model.advance_id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSave () {
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveAddNew () {
      this.waiting_new = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    async clearInput () {
      this.model.advance_id = null
      this.model.advance_date = moment().format('DD-MM-YYYY')
      this.model.advance_amount = null
      this.model.amount_used = 0
      this.model.amount_due = 0
      this.model.purpose = null
      this.model.description = null
      this.model.fx_rate = null
      this.model.vendor_name = null
      // this.model.advanced_by = null
      this.model.bank_id = null
      this.model.account_name = null
      this.model.account_number = null
    },
    setEditData () {
      if (!_.isEmpty(this.edit_data)) {
        this.model.advance_id = this.edit_data.advance_id
        this.model.advance_date = this.edit_data.advance_date
        this.model.currency_id = this.edit_data.currency_id
        this.model.advance_amount = this.edit_data.advance_amount
        this.model.amount_used = this.edit_data.amount_used
        this.model.amount_due = this.edit_data.amount_due
        this.model.purpose = this.edit_data.purpose
        this.model.description = this.edit_data.description
        this.model.fx_rate = this.edit_data.fx_rate
        this.model.vendor_name = this.edit_data.vendor_name
        this.model.advanced_by = this.edit_data.advanced_by
        this.model.bank_id = this.edit_data.bank_id
        this.model.account_name = this.edit_data.account_name
        this.model.account_number = this.edit_data.account_number
      } else {
        this.model.advanced_by =
          this.$store.state.authUser.user.employee.employee_id
      }
    }
  }
}
</script>
